<template>
  <div class="pc-layout">
    <!-- head部分 -->
    <pc-head :notHome="notHome"></pc-head>
    <!-- 主体部分 -->
    <div class="content">
      <slot></slot>
    </div>
    <!-- footer部分 -->
    <pc-footer></pc-footer>
  </div>
</template>
<script>
import PcHead from "../../components/computer/Head";
import PcFooter from "../../components/computer/Footer";
export default {
  components: {
    PcHead,
    PcFooter,
  },
  computed: {
    notHome() {
      console.log(this.$route.path, "跳转");
      return this.$route.path !== "/";
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-layout {
  .content {
    min-height: calc(100vh - 294px);
    min-width: 1250px;
    background: $blue_bg;
  }
}
</style>
